import React from "react";
import {
  makeStyles,
  shorthands,
  tokens,
  Text,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { t } from "../../i18n/i18n";
import { CheckmarkCircleRegular } from "@fluentui/react-icons";
import { CtaButton } from "../common/input/CtaButton";
import { PageSection } from "../common/pageSection/PageSection";

const useStyles = makeStyles({
  cardWrapper: {
    width: "60%",
    ...shorthands.margin(0, "auto"),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: tokens.spacingVerticalXXXL,
    ...shorthands.padding(
      tokens.spacingVerticalXXXL,
      tokens.spacingHorizontalXXXL
    ),
    ...shorthands.borderRadius("20px"),

    rowGap: tokens.spacingVerticalXL,
    color: tokens.colorBrandBackground,
    backgroundColor: "#FFFFFF",
  },
  checkmark: {
    width: "200px",
    height: "200px",
    color: "#30873F",
  },
  bodyText: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXS,
    textAlign: "center",
    maxWidth: "60%",
  },
});

export const OrderThankYou = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <PageSection>
      <div className={classes.cardWrapper}>
        <CheckmarkCircleRegular className={classes.checkmark} />

        <Text size={800} weight="bold">
          {t("ThankYouForYourOrder")}
        </Text>
        <div className={classes.bodyText}>
          <Text size={500}>{t("WeHaveReceivedYourOrder")}</Text>
          <Text size={500}>{t("WeWillContactYouSoon")}</Text>
        </div>
        <CtaButton buttonText={t("Home")} onClick={() => navigate("/")} />
      </div>
    </PageSection>
  );
};
